/**
 * Adresa obrázka karty. Server ho posiela s ročnou `immutable` cache, preto
 * adresa nesie verziu: keď sa obrázky zmenia (napr. kvalitnejšie verzie
 * z `scripts/fetch-hd-cards.mjs`), zvýši sa `VERSION` a prehliadače aj
 * Cloudflare si ich stiahnu nanovo.
 */
const VERSION = 3;

export function cardImageUrl(cardId: string): string {
  return `/api/cards/${encodeURIComponent(cardId)}/image?v=${VERSION}`;
}
